import { render, staticRenderFns } from "./sys0010.vue?vue&type=template&id=4f31636d"
import script from "./sys0010.vue?vue&type=script&lang=js"
export * from "./sys0010.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports